enum REPORTS {
  EDR = 'EDR',
  EXEC = 'EXEC',
  MDR = 'MDR',
  VMP = 'VMP'
}

export { REPORTS };
export default REPORTS;
